import { observable, configure } from "mobx";
import React from "react";
import ReactDOM from "react-dom/client";
import "./output.css";
import App from "./App.jsx";
import reportWebVitals from "./reportWebVitals.js";
import { model } from "./planetModel.js";
import { NextUIProvider } from "@nextui-org/react";

// ------------ FIREBASE CONFIG -----------
import "./firebaseModel.js";
import { connectToFirebase } from "./firebaseModel.js";
import { reaction } from "mobx";
// ------------ FIREBASE CONFIG -----------

configure({ enforceActions: "never" }); // we don't use Mobx actions
const reactiveModel = observable(model);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <NextUIProvider>
    <main className="dark text-foreground bg-background">
      <App model={reactiveModel} />
    </main>
  </NextUIProvider>
  // </React.StrictMode>
);

connectToFirebase(reactiveModel, (checkACB, sideEffectACB) => {
  // Use Mobx reaction to watch for changes in relevant model properties
  reaction(
    () => checkACB(),
    () => sideEffectACB(),
    { fireImmediately: true } // Set fireImmediately to true to run the sideEffectACB initially
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

window.myModel = reactiveModel;
